<script lang="ts" setup>
import { theme as brandTheme } from '@/config/brands'

defineProps<{
  config: any
  records: any[]
  fetching: boolean
  ending: boolean
  page: number
  setInfiniteRef: (el: HTMLElement | null) => void
  gotoChapter: (item: any) => void
}>()

const pageBgColor = brandTheme.bgGlobal || '#14181F'
</script>

<template>
  <div :ref="setInfiniteRef" class="h-screen overflow-scroll" :style="{ background: pageBgColor }">
    <BasicNavbar class="color-n-text-2" />

    <div v-if="!fetching && page === 1 && records.length === 0" class="mt-11 pt-15vh w-full text-center flex flex-col justify-center">
      <BizBlockEmpty :title="config.texts.noRecord" />
    </div>
    <div v-else class="rr-page-body px-4">
      <div v-for="(item, index) in records" :key="index">
        <div class="rr-consume-item" @click="gotoChapter(item)">
          <div class="relative">
            <img class="w-18 h-25 rounded-8px" :src="item.contentCoverUrl">
          </div>
          <div class="flex-1 min-w-0">
            <template v-if="item.chapterName !== '0'">
              <p class="text-15px font-bold line-clamp-1 text-n-text-1">
                {{ item.chapterName }}
              </p>
              <p class="text-13px mt-5px text-n-text-3 line-clamp-1">
                <span>{{ item.contentName }}</span>
              </p>
            </template>
            <template v-else>
              <p class="text-15px font-bold line-clamp-2 text-n-text-1">
                {{ item.contentName }}
              </p>
            </template>
            <p class="flex justify-between text-12px mt-8px text-n-text-3">
              <span>{{ $d(new Date(item.subscriptionTime), 'short') }}</span>
              <span>-{{ item.coinNum }} {{ config.texts.coins }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div v-if="ending && records.length" class="py-15px text-13px text-n-text-3 text-center">
      {{ config.texts.noMore }}
    </div>
    <div v-else-if="fetching" class="py-15px flex items-center justify-center text-13px text-n-text-3">
      <div class="animate-spin">
        <i-icon-park-outline-loading />
      </div>
    </div>
  </div>
</template>

<style scoped>
.rr-page-body {
  padding-top: 2px;
}

.rr-consume-item {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 14px;
  padding: 10px;
  background: rgba(255, 255, 255, 0.02);
}
</style>
